"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _omit = require("../utilities/omit");
var _merge = _interopRequireDefault(require("./merge"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function css(styleFunction) {
  const newStyleFunction = props => {
    const output = styleFunction(props);
    if (props.css) {
      return _objectSpread(_objectSpread({}, (0, _merge.default)(output, styleFunction(_objectSpread({
        theme: props.theme
      }, props.css)))), (0, _omit.omit)(props.css, styleFunction.filterProps));
    }
    return output;
  };
  newStyleFunction.filterProps = ['css', ...(styleFunction.filterProps || [])];
  return newStyleFunction;
}
var _default = exports.default = css;